import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function AidesLocalesPage() {
  const aide = getAideAgricoleStub('aides-locales');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
